/**
 * @prettier
 */
export function transformPercentageToString(value?: number | null): string {
    return value ? (value * 100).toString() : '';
}
